import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Form } from "react-bootstrap";
import Option from "./Option/Option";
import { useEffect, useRef, useState } from "react";
import ChoiceLimits, { limitsOf } from "components/groups/ChoiceLimits/ChoiceLimits";
import Select from "components/Ui/SelectField/SelectField";

const OptionGroup = (props) => {
    const [optionsNumber, setOptionsNumber] = useState(0);
    const [options, setOptions] = useState([]);
    const [optionsValues, setOptionsValues] = useState([]);
    const groupName = useRef();
    const single = useRef();
    // The choice limits of this group, sent with each change of the form.
    const limits = useRef(limitsOf(props.group));

    const [generalOptions, setGeneralOptions] = useState([]);

    useEffect(() => {
        if (props.options) {
            setGeneralOptions(props.options.map((o) => ({ value: o.id, label: o.name })));
        }
    }, []);

    const setOptionData = (data) => {
        const options = [...optionsValues];
        options[data.id] = data;
        setOptionsValues(options);
        props.getOptionData({
            id: props.index,
            name: groupName.current.value,
            type: single.current.children[0].checked ? "multi" : "single",
            ...limits.current,
            options: options,
        });
    };

    const onChangeInputs = (e) => {
        props.getOptionData({
            id: props.index,
            name: groupName.current.value,
            type: single.current.children[0].checked ? "multi" : "single",
            ...limits.current,
            options: optionsValues,
        });
    };

    useEffect(() => {
        const optionList = [];
        for (let i = 0; i < optionsNumber; i++) {
            optionList.push(<Option key={i} setOptionData={setOptionData} />);
        }
        setOptions(optionList);
    }, [optionsNumber]);

    const handleChange = (selectedOption) => {
        setOptionData({
            id: optionsValues.length,
            generalOptionId: selectedOption.value,
            generalOptionName: selectedOption.label,
            value: 0,
            group: props.index,
        });
    };

    return (
        <div className="group">
            <div className="mb-2" style={{ display: "flex" }}>
                <Form.Group className="mb-3" controlId="group-name" style={{ flexGrow: 1 }}>
                    <Form.Label>
                        اسم الخيار<span style={{ color: "red" }}>*</span>
                    </Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="اسم الخيار"
                        ref={groupName}
                        required
                        onChange={onChangeInputs}
                    />
                </Form.Group>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                defaultChecked={false}
                                color="warning"
                                onChange={onChangeInputs}
                                ref={single}
                            />
                        }
                        label="خيار متعدد"
                    />
                </FormGroup>
            </div>
            <ChoiceLimits
                group={props.group}
                onChange={(values) => {
                    limits.current = values;
                    onChangeInputs();
                }}
            />
            <div className="mb-3">
                <Form.Label>خيارات عامه</Form.Label>
                <Select
                    style={{ width: "50%" }}
                    // value={generalOptions}
                    options={generalOptions}
                    onChange={handleChange}
                />
            </div>
            {optionsValues.map((item) => (
                <Option
                    index={item.id}
                    groupIndex={props.index}
                    generalOptionId={item.generalOptionId}
                    generalOptionName={item.generalOptionName}
                    key={item.id}
                    getOptionData={setOptionData}
                    options={props.options}
                />
            ))}
            <div>
                <button
                    style={{ background: "red", color: "#fff" }}
                    // disabled={optionsNumber === 0 ? true : false}
                    onClick={() => {
                        const o = optionsValues;
                        o.pop();
                        setOptionsValues([...o]);
                    }}
                    type="button"
                >
                    حذف
                </button>
            </div>
            <hr />
        </div>
    );
};
export default OptionGroup;
